import React from "react";
import OrderTable from "../Table";

const PrescriptionRejected = () => {
  return <OrderTable type="Prescription Rejected" />;
};

export default PrescriptionRejected;
